import { useCallback } from 'react'

import type { ProductKeys } from '@/legacy/components/Products/constants'
import { useSelectCardEvent } from '@/legacy/core/analytics/hooks'

import CardFooter from './Card/ModernCardFooter'
import CardHeader from './Card/ModernCardHeader'
import CardLoading from './Card/ModernCardLoading'
import CardMain from './Card/ModernCardMain'
import * as CardStyles from './Card/styles'

export interface Props {
  title: string
  url: string
  image: string
  alt: string
  category?: string
  product?: ProductKeys
  date?: number | string
  readingTime?: string
  className?: string
  modifier?: 'large' | 'default' | 'horizontal'
  forceFocus?: boolean
}

const ModernBlogCard = ({
  title,
  image,
  alt,
  product,
  date,
  readingTime,
  modifier = 'default',
  forceFocus = false,
  url,
  ...props
}: Props) => {
  const handleGAEvent = useSelectCardEvent()
  const handleOnClickCta = useCallback(() => {
    handleGAEvent({ label: title })
  }, [handleGAEvent, title])

  return (
    <li>
      <CardStyles.Container
        forceFocus={forceFocus}
        tag="article"
        modifier={modifier}
        role="contentinfo"
        {...props}
      >
        <CardHeader image={image} alt={alt} product={product} />
        <CardMain title={title} date={date} readingTime={readingTime} />
        <CardFooter url={url} handleOnClickCta={handleOnClickCta} title={title} />
      </CardStyles.Container>
    </li>
  )
}

ModernBlogCard.Loading = CardLoading

export default ModernBlogCard
